import colors from '@rodeo-dev/legos/dist/themes/colors'
import styled from 'styled-components'
import { Link } from '../../../../components/link'

const StyledLink = styled(Link)`
  display: inline-block;
  height: 100%;
  padding: 1.125rem 1.25rem;
  text-decoration: none;
  width: 100%;
`

const SubTitle = styled.p`
  color: ${colors.default.dark};
  font-size: 0.75rem;
`

const Title = styled.div`
  color: ${colors.primary.dark};
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`

export { StyledLink, SubTitle, Title }
